import { render } from "./scmc.vue?vue&type=template&id=3f5c03cb&ts=true"
import script from "./scmc.vue?vue&type=script&lang=ts"
export * from "./scmc.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__